module.exports = __webpack_public_path__ + "static/media/08.11.5235b68c.webp";